import { render, staticRenderFns } from "./ConfirmRequest.vue?vue&type=template&id=2caaa9d0&"
import script from "./ConfirmRequest.vue?vue&type=script&lang=js&"
export * from "./ConfirmRequest.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports